import { render, staticRenderFns } from "./customsInfoDialogOuj.vue?vue&type=template&id=b7a4e17a&"
import script from "./customsInfoDialogOuj.vue?vue&type=script&lang=js&"
export * from "./customsInfoDialogOuj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7a4e17a')) {
      api.createRecord('b7a4e17a', component.options)
    } else {
      api.reload('b7a4e17a', component.options)
    }
    module.hot.accept("./customsInfoDialogOuj.vue?vue&type=template&id=b7a4e17a&", function () {
      api.rerender('b7a4e17a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/ouJian/customsInfoDialogOuj.vue"
export default component.exports